// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Rubik', sans-serif;
}

.weight-update-page {
  padding: 20px;
  text-align: center;
}

.weight-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
}

.weight-container {
  width: 320px;
  padding: 20px;
  background-color: #A5D6A7;
  border-radius: 15px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  margin: 0 auto;
  text-align: center;
}

.weight-input {
  width: 75%;
  padding: 12px;
  margin: 12px 0;
  border: 2px solid #007bff;
  border-radius: 8px;
  font-size: 16px;
  text-align: center;
  background-color: white;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.update-button {
  width: 85%;
  padding: 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.update-button:hover {
  background-color: #0056b3;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}

.update-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.error-text {
  color: red;
  font-size: 14px;
  margin-bottom: 10px;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-content {
  background: white;
  padding: 20px;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  width: 300px;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.popup h3 {
  margin-bottom: 10px;
  font-size: 20px;
  color: #28a745;
}

.popup p {
  font-size: 16px;
  margin-bottom: 10px;
}

.close-button {
  padding: 8px 15px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
}

.close-button:hover {
  background-color: #218838;
}

.feedback1-input {
  width: 83% !important;
  height: 100px;
  padding: 12px;
  margin: 12px 0;
  border: 2px solid #007bff;
  border-radius: 8px;
  font-size: 16px;
  text-align: center;
  background-color: white;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

@media (max-width: 600px) {
  .weight-update-page {
    padding-left: -50px;
  }
}

.weight-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/WeightUpdatePage.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uBAAuB;EACvB,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX","sourcesContent":["body {\n  font-family: 'Rubik', sans-serif;\n}\n\n.weight-update-page {\n  padding: 20px;\n  text-align: center;\n}\n\n.weight-title {\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.weight-container {\n  width: 320px;\n  padding: 20px;\n  background-color: #A5D6A7;\n  border-radius: 15px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n  margin: 0 auto;\n  text-align: center;\n}\n\n.weight-input {\n  width: 75%;\n  padding: 12px;\n  margin: 12px 0;\n  border: 2px solid #007bff;\n  border-radius: 8px;\n  font-size: 16px;\n  text-align: center;\n  background-color: white;\n  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.update-button {\n  width: 85%;\n  padding: 12px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n}\n\n.update-button:hover {\n  background-color: #0056b3;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n}\n\n.update-button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.error-text {\n  color: red;\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup-content {\n  background: white;\n  padding: 20px;\n  text-align: center;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n  width: 300px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.popup h3 {\n  margin-bottom: 10px;\n  font-size: 20px;\n  color: #28a745;\n}\n\n.popup p {\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n\n.close-button {\n  padding: 8px 15px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.close-button:hover {\n  background-color: #218838;\n}\n\n.feedback1-input {\n  width: 83% !important;\n  height: 100px;\n  padding: 12px;\n  margin: 12px 0;\n  border: 2px solid #007bff;\n  border-radius: 8px;\n  font-size: 16px;\n  text-align: center;\n  background-color: white;\n  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);\n  box-sizing: border-box;\n}\n\n@media (max-width: 600px) {\n  .weight-update-page {\n    padding-left: -50px;\n  }\n}\n\n.weight-title {\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
